import { startSlidingPills } from '@ck/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@ck/ui/styles.css';
import { initClickSpark, initSpotlight } from '@ck/ui';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

initSpotlight();
initClickSpark();
startSlidingPills();
